<template>
  <!-- 题目类组件 -->
  <div class="ModuleTopic">
    <check-box v-if="questionType==2||questionType==3" :data="obj" :disabledBol="disabledBol"></check-box>
    <bl-input v-else-if="questionType==6" :data="obj" :disabledBol="disabledBol"></bl-input>
    <short-answer v-else-if="questionType==8||questionType==10" :data="obj" :disabledBol="disabledBol"></short-answer>
    <Rate v-else-if="questionType==7" :data="obj" :disabledBol="disabledBol"></Rate>
    <Submit v-else-if="questionType==9" :data="obj" :disabledBol="disabledBol"></Submit>
    <select-box v-else-if="(questionType==1)&&(obj.rule?obj.rule.isSelect==1:false)" :data="obj" :disabledBol="disabledBol"></select-box>
    <select-date v-else-if="questionType==11" :data="obj" :disabledBol="disabledBol"></select-date>
    <inventory-box v-else-if="questionType==12" :data="obj" :disabledBol="disabledBol"></inventory-box>
    <!-- 写作 -->
    <writing-box v-else-if="questionType==13" :data="obj" :disabledBol="disabledBol"></writing-box>
  </div>
</template>

<script>

import CheckBox from './public/check-box'
import blInput from './public/input'
import ShortAnswer from './public/short-answer'
import Rate from './public/rate'
import Submit from './public/submit'
import SelectBox from './public/select-box'
import SelectDate from './public/select-date'
import InventoryBox from './public/inventory-box'
import WritingBox from './public/writing-box'

export default {
  props: {
    data: Object,
    topicList: Object,
    disabledBol: Boolean
  },
  name: 'ModuleTopic',
  data () {
    return {
      questionType: null,      // 题目类型
      obj: null                // 题目内容
    }
  },
  methods: {
    // 获取题目
    getTopic (id) {
      // console.log(this.topicList[this.data.questionId])
      this.obj = this.topicList[this.data.questionId]
      console.log(this.obj, 'obj')
      this.questionType = this.obj.questionType
      this.$emit('getTopic', this.obj)
      // let data = {
      //   questionId: this.data.questionId,
      //   taskRelationId: this.$route.query.taskRelationId
      // }
      // this.$api.post('BANK_GET_QUESTION', data, (res) => {
      //   this.obj = res.data
      //   this.questionType = res.data.questionType
      //   this.$emit('getTopic', this.obj)
      // })
    }
  },
  watch: {
    'topicList' () {
      this.getTopic()
    }
  },
  created () {
    // this.getTopic()
  },
  components: {
    CheckBox,
    blInput,
    ShortAnswer,
    Rate,
    Submit,
    SelectBox,
    SelectDate,
    InventoryBox,
    WritingBox
  }
}
</script>

<style lang="scss">
.ModuleTopic{
  .el-input__icon{
    font-style: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/main.vue